import styled from 'styled-components';
import { Box, Theme } from '@material-ui/core';

const theme = (props: any) => {
  return props.theme as Theme;
}

export const AppBody = styled(Box)(props => ({
  paddingTop: theme(props).spacing(8),
  paddingBottom: theme(props).spacing(6.25),
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  background: theme(props).palette.common.white,
})) as typeof Box;